export const MenuData = [
  { title: 'About', link: '/about' },
  { title: 'Home', link: '/home' },
  { title: 'Estate', link: '/estate' },
  { title: 'Residential', link: '/residential' },
  { title: 'Office', link: '/office' },
];
